import React from 'react';
import {
  Card,
  Info,

  Seporator,
  Actions
} from './Styles'

import Country from 'components/Country'
import { UserMeta, UserInfoBlock } from '../'
import { IPublicStruct } from 'interfaces/IPublicStruct';
import UserInfoState from '../UserInfo/UserInfoState'

interface props {
  data: IPublicStruct;
  buttons?: React.ReactElement[];
  fill?: 'solid' | 'outline'
}

export function UserCard({ data, buttons, fill = 'outline' }: props) {

  const languagesList = data.user.languages.map((item, index) => {
    return <Country name={item} key={index} />
  })

  return (
    <Card className={fill} onClick={() => UserInfoState.toggle()}>
      <UserMeta user={data.user} />

      <Info>

        <UserInfoBlock title="Languages" description={languagesList} />

        <Seporator />

        {data.info.map((item, index) => {
          return (
            <UserInfoBlock key={index} title={item.title} description={item.description} />
          )
        })}

        <Actions>
          {Array.isArray(buttons) && buttons.map((item, index) => {
            return <React.Fragment key={index}>{item}</React.Fragment>
          })}
        </Actions>

      </Info>
    </Card>
  )
}